import { Injectable } from '@angular/core';
import SafeUrlAssembler from 'safe-url-assembler';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../core/services/http/http-client.service';
import { Location } from '../../models/location/location.model';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';

@Injectable()
export class ContactService {  

  constructor( private httpClientService: HttpClientService, private apiEndpointService: ApiEndpointService) {
    
  }

  /**
   * Gets Account Payable Contact Address.
   *
   * @param {string(true/false)} Expect1row
   * @returns {Observable<Location[]>}
   */
  public getContactAp(Expect1row: string): Observable<Location[]> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getApContact'))
      .param('Except1row', Expect1row).toString();
    return this.httpClientService.get<Location[]>(endpoint);
  }

  /**
   * Gets Corporate(Company) Contact Address.
   *
   * @returns {Observable<Location[]>}
   */
  public getCorporateContact(): Observable<Location[]> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getCorporateContact')).toString();
    return this.httpClientService.get<Location[]>(endpoint);
  }

  /**
   * Gets Mailing Contact Address.
   *
   * @returns {Observable<Location[]>}
   */
  public getMailingContact(): Observable<Location[]> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getMailingContact')).toString();
    return this.httpClientService.get<Location[]>(endpoint);
  }
}
